<template>
  <main
    class="relative tablet:min-h-[100vh] overflow-auto laptop:min-h-screen laptop:max-h-screen font-roboto laptop:overflow-hidden laptop:flex items-center justify-center h-full bg-[#FDF9EE]">
    <div class="absolute top-0 left-0 w-full h-full">
      <div class="w-full h-[25vh] tablet:landscape:h-[37vh] desktop:landscape:h-[50vh] tablet:h-[30vh] laptop:h-[50vh] bg-[#2459A8] "></div>
      <div class="w-full h-[75vh] tablet:h-[70vh] laptop:h-[50vh] bg-[#FDF9EE] "></div>
    </div>
    <div class="relative z-10 max-w-[90%] mx-auto py-[40px] laptop:p-0">
      <div
        class="grid grid-cols-1 laptop:grid-cols-5 largeDesktop:grid-cols-3 tablet:items-center largeDesktop:gap-[50px]">
        <div
          class="laptop:col-span-3 largeDesktop:col-span-2 flex flex-col laptop:gap-[30px] largeDesktop:gap-[100px] mb-[30px] laptop:m-0">
          <img src="../../assets/images/myHappyHomeLogo.svg" alt="Logo" @click="logoClicked()" 
            class="w-[155px] h-[70px] laptop:w-[230px] laptop:h-[100px] largeDesktop:w-[290px] largeDesktop:h-[130px] object-contain cursor-pointer hover:animate-jelly">
          <div class="transform transition-transform duration-[500ms] hover:scale-[1.02] flex justify-end laptop:block">
            <img src="../../assets/images/myHappyHomeFamilyImg.png" alt="Logo"
              class="animate-float w-[280px] h-[170px] tablet:w-[500px] tablet:h-[300px] laptop:w-full laptop:h-[400px] largeDesktop:w-full largeDesktop:h-[620px] object-contain">
          </div>
        </div>
        <verificationComponent :callbacks="handleCallback" />

      </div>
    </div>

  </main>
</template>

<script>
import verificationComponent from "../../components/authComponent/verificationComponent.vue";

export default {
  components: {
    verificationComponent
  },
  data() {
    return {
    };
  },

  computed: {

  },

  watch: {

  },

  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.$el && this.$el.scrollTop !== undefined) {
      this.$el.scrollTop = 0;
    }
  },
  methods: {
    logoClicked() {
      window.location = process.env.VUE_APP_HOME_PAGE_URL
    },
    handleCallback(option) {
      if (option == "verified") {
        if (this.$route.query.redirectTo) {
          this.$router.push(this.$route.query.redirectTo);
        } else {
          this.$router.push({
            name: 'dashboard'
          })
        }
      } else if (option == "back") {
        this.$router.go(-1)
      }
    }
  },
  unmounted() {

  },
};
</script>